import { MessageRowsType } from "@/components/chat/MessageRow"
import MessageHelpers from "@/lib/messageHelpers"
import { MessageDisplayType } from "@/reducers/messagesSlice"
import useMessageHighlight from "@/hooks/useMessageHighlight"
import { useCallback, useState } from "react"
import { useLongPress } from "@uidotdev/usehooks"
import type { AccountChat } from "@/lib/accountChatsParser"

export function useMessageRowState(
  rows: MessageRowsType,
  accountChat?: AccountChat,
) {
  const [
    previousMessageOrMessageGroup,
    messageOrMessageGroup,
    nextMessageOrMessageGroup,
  ] = rows

  const [actionButtonsVisible, setActionButtonsVisible] = useState(false)

  const onLongPress = useLongPress(
    () => {
      navigator.vibrate?.(10)
      setActionButtonsVisible((prevValue) => !prevValue)
    },
    {
      threshold: 500,
    },
  )

  const isLastRow = !nextMessageOrMessageGroup

  const grouped = MessageHelpers.shouldGroup(
    messageOrMessageGroup,
    previousMessageOrMessageGroup,
    accountChat,
  )

  const isLastInGrouped =
    !MessageHelpers.shouldGroup(
      messageOrMessageGroup,
      nextMessageOrMessageGroup,
      accountChat,
    ) || isLastRow

  const isFirstInGrouped = MessageHelpers.shouldGroup(
    messageOrMessageGroup,
    nextMessageOrMessageGroup,
    accountChat,
  )

  const messageForRowActions =
    messageOrMessageGroup.displayType === MessageDisplayType.MessageGroup
      ? messageOrMessageGroup.messages[0]
      : messageOrMessageGroup

  const isHighlighted = useMessageHighlight(messageForRowActions)

  const hideActionButtons = useCallback(
    () => setActionButtonsVisible(false),
    [],
  )

  return {
    isLastRow,
    grouped,
    isLastInGrouped,
    isFirstInGrouped,
    messageForRowActions,
    previousMessageOrMessageGroup,
    messageOrMessageGroup,
    nextMessageOrMessageGroup,
    isHighlighted,
    actionButtonsVisible,
    hideActionButtons,
    onLongPress,
  }
}
